import Brand from "./Brand";

export default class BrandRequestBrand {
	id;
	/** @type {Brand} */
	brand;
	/** @type {number} */
	status;
	/** @type {'JaroMetricName'|'VisualSimilarity'} */
	comparisonMethod;

	/**
	 * 
	 * @param {Partial<BrandRequestBrand>=} initialState 
	 */
	constructor(initialState) {
		Object.assign(this, initialState);
	}
}


// WEBPACK FOOTER //
// ./src/models/BrandRequestBrand.js